import { Box, CircularProgress, Modal, Typography } from "@mui/material"
import React, { useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import useStyles from "./useStyles"

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 550,
  height: 350,
  bgcolor: "white",
  p: 3,
  borderRadius: "8px",
  boxShadow: "0px 0px 4px rgba(36, 55, 143, 0.4)",
}

export const ConfirmModalCognito = ({
  openModal,
  handleClose,
  handleConfirmFunction,
  isActivate,
}) => {
  const classes = useStyles()
  const [showCircularProgress, setShowCircularProgress] = useState(false)

  return (
    <>
      <Modal open={openModal} onClose={handleClose}>
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <CloseIcon
              sx={{
                fontSize: "medium",
                color: "#263057",
                // eslint-disable-next-line comma-dangle
                cursor: "pointer",
              }}
              onClick={handleClose}
            />
          </div>

          <div>
            <Typography
              sx={{ color: "#263057", fontSize: "1.3em", fontWeight: 500 }}
            >
              Configuración del Doble Factor de Autenticación (2FA)
            </Typography>
          </div>
          <Typography
            sx={{
              color: "#263057",
              fontFamily: "Roboto",
              marginTop: "1rem",
              fontWeight: 500,
            }}
          >
            ¿Está seguro que desea{" "}
            {isActivate ? "deshabilitarle" : "habilitarle"} el 2FA al usuario?
          </Typography>
          <div
            style={{
              color: "#263057",
              fontFamily: "Roboto",
              fontSize: 14,
              marginTop: "1rem",
              letterSpacing: "0.2px",
              whiteSpace: 'pre-line'
            }}
          >
            Recuerde que{" "}
            {isActivate
              ? `antes de hacerlo desde aquí, debe deshabilitarlo desde la consola web del proveedor de autenticación Cognito (Temporalmente deberá solucionarse de esta manera, hasta la futura implementación de la funcionalidad en esta sección)\nSi no lo hace el usuario no podrá iniciar sesión ya que Cognito seguirá requiriendo que el usuario valide su identidad y desde nuestro sistema figurará que el usuario NO tiene activado el 2FA`
              : `una vez habilitado el 2FA el usuario deberá validar su identidad cada vez que inicie sesión mediante cualquiera de los métodos habilitados:
             - Enviar un código al correo electrónico del usuario 
             - Generar un código desde una aplicación móvil de autenticación (Google Authenticator, Microsoft Authenticator)

            Para desactivar el 2FA recuerde que antes de hacerlo desde aquí, debe hacerlo desde la consola web del proveedor de autenticación Cognito (Temporalmente deberá solucionarse de esta manera, hasta la futura implementación de la funcionalidad en esta sección).`}
          </div>

          <Box className={classes.buttons} style={{ marginLeft: "45%" }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              setShowCircularProgress={setShowCircularProgress}
              handleConfirmFunction={handleConfirmFunction}
              handleClose={handleClose}
            />

            <ButtonClose handleClose={handleClose} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm({
  showCircularProgress,
  setShowCircularProgress,
  handleConfirmFunction,
  // eslint-disable-next-line comma-dangle
  handleClose,
}) {
  // eslint-disable-next-line semi
  const classes = useStyles()
  const [isProgressComplete, setProgressComplete] = useState(false)

  const handleButtonClick = async () => {
    if (!isProgressComplete && !showCircularProgress) {
      setShowCircularProgress(true)
      handleClose()
      await handleConfirmFunction()
      setShowCircularProgress(false)
      setProgressComplete(true)
      
    }
  }

  return (
    // eslint-disable-next-line quotes
    <div style={{ position: "relative", display: "inline-block" }}>
      <button
        className={`${classes.confirmButton} ${
          isProgressComplete ? classes.disabledButton : ""
        }`}
        disabled={isProgressComplete || showCircularProgress}
        onClick={handleButtonClick}
      >
        {showCircularProgress ? (
          <CircularProgress size="1.5rem" color="inherit" />
        ) : (
          <Typography className={classes.confirmButtonTypography}>
            Aceptar
          </Typography>
        )}
      </button>
    </div>
  )
}

function ButtonClose({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
